import { render } from "./TaskExtractorModal.vue?vue&type=template&id=533f5acc&scoped=true"
import script from "./TaskExtractorModal.vue?vue&type=script&lang=js"
export * from "./TaskExtractorModal.vue?vue&type=script&lang=js"

import "./TaskExtractorModal.vue?vue&type=style&index=0&id=533f5acc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533f5acc"]])

export default __exports__